import React, { useContext } from 'react';
import './contacto.css';
import { contactoMainBanner, contactoMainBannerEn } from '../../json/contacto/mainBanner';
import MainBanner from '../Nosotros/MainBanner/MainBanner';
import { LanguageContext } from '../../context/LanguageContext/LanguageContext';
import Mapa from './Mapa/Mapa';
import Form from './Form/Form';

const Contacto = () => {
    const { language } = useContext(LanguageContext);

    const data = language === 'ES'
        ? contactoMainBanner[0]
        : contactoMainBannerEn[0];
    return (
        <div>
            <MainBanner {...data} />
            <Mapa />
            <Form />
        </div>
    )
}

export default Contacto